var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationArrowForward = function SvgIllustrationArrowForward(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 360",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 245.4,
    cy: 254.1,
    r: 55.6,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 245.4 254)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 107.6,
    r: 55.6,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 114 107.6)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-fill)",
    d: "m267.913 123.889 4.463-37.435 37.435 4.464-4.464 37.435zM50 277.4l8.288-36.778 36.778 8.289-8.288 36.777z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M183 96.6c-48.7 0-88.4 39-88.4 86.8A87.7 87.7 0 0 0 183 270c48.7 0 88.4-39 88.4-86.7A87.7 87.7 0 0 0 183 96.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "M182.9 211.5c-.7-.7-1.1-1.6-1.1-2.7 0-1 .3-2 1-2.7l18.9-18.9h-43.1c-1.1 0-2-.4-2.8-1a3.7 3.7 0 0 1-1.1-2.8c0-1.1.4-2 1.1-2.8.7-.7 1.7-1.1 2.8-1.1h43l-18.8-19c-.7-.6-1-1.5-1-2.6s.4-2 1-2.7c.8-.7 1.7-1 2.8-1 1 0 2 .3 2.7 1l25.4 25.5q.6.45.9 1.2a4.7 4.7 0 0 1 0 3l-.9 1.2-25.4 25.4c-.7.7-1.6 1-2.7 1s-2-.3-2.7-1"
  })));
};
export default SvgIllustrationArrowForward;